<script setup>
const items = [
  {
    label: 'Accueil',
    to: '/',
  },
  {
    label: 'Qui sommes-nous ?',
    to: '/qui-sommes-nous',
  },
  {
    label: 'Nos prestations',
    to: '/prestations',
  },
  {
    label: 'Nos formations',
    children: [
      {
        label: 'Toutes nos formations',
        description: 'Vue d\'ensemble de nos formations aux premiers secours en Belgique.',
        to: '/formations',
      },
      {
        label: 'Stages Secouristes Juniors',
        description: 'Formation aux premiers secours pour les enfants à partir de 6 ans.',
        to: '/formations/stages-secouristes-juniors',
      },
      {
        label: 'Formations grand public',
        description: 'Formation de secouriste (aussi appelée secouriste industriel) dès 15 ans.',
        to: '/formations/formations-grand-public',
      },
      {
        label: 'Secouriste en entreprise',
        description: 'Formation de secouriste dans vos locaux, sur devis.',
        to: '/formations/secouriste-entreprise',
      },
      {
        label: 'Recyclage secouriste',
        description: 'Remise à niveau des secouristes, sur devis.',
        to: '/formations/recyclage',
      },
      {
        label: 'Formation ATNUP',
        description: 'Ambulancier de Transport Non Urgent de Patients à Virton avec l\'ILLEPS.',
        to: '/formations/atnup-virton',
      },
    ],
  },
  {
    label: 'Contactez-nous',
    to: '/contact',
  },
]

const trackNavigationCta = (cta) => {
  if (import.meta.client) {
    useTrackEvent('CTA: Navigation', {
      props: {
        cta,
      },
    })
  }
}
</script>

<template>
  <UHeader class="sticky top-2 z-40 mx-auto mb-3 w-[95%] max-w-7xl rounded-[var(--radius-tile)] border border-brand-blue-100/80 bg-white/88 px-2 shadow-xl shadow-brand-blue-900/10 backdrop-blur-xl dark:border-gray-700 dark:bg-gray-900/88 md:mb-4">
    <template #left>
      <NuxtLink
        to="/"
        aria-label="Aller à l'accueil"
        class="flex items-center gap-3"
      >
        <UColorModeImage
          light="/images/logo.png"
          dark="/images/logo-light.png"
          class="h-10 w-auto"
          alt="Logo AP 2.0"
          width="80"
          height="80"
          format="webp"
          loading="eager"
        />
        <span class="hidden text-xs font-semibold tracking-wide text-brand-blue-700 dark:text-blue-200 xl:inline-block">
          Ambulance Présent 2.0
        </span>
      </NuxtLink>
    </template>

    <UNavigationMenu
      highlight
      highlight-color="primary"
      orientation="horizontal"
      class="data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-48 data-[orientation=horizontal]:justify-center"
      :items="items"
    />

    <template #right>
      <UColorModeSwitch size="sm" />

      <UButton
        variant="soft"
        to="/postuler"
        label="Postuler"
        class="hidden md:inline-flex"
        aria-label="Devenir volontaire"
        @click="trackNavigationCta('postuler')"
      />

      <UButton
        to="/devis"
        label="Devis"
        class="shadow-md shadow-brand-blue-600/20"
        aria-label="Demander un devis"
        @click="trackNavigationCta('devis')"
      />

      <UButton
        variant="ghost"
        to="/volontaires/connexion"
        target="_blank"
        icon="i-heroicons-arrow-right-on-rectangle"
        class="hidden md:inline-flex"
        aria-label="Accéder à l'espace volontaires"
        @click="trackNavigationCta('volontaires_connexion')"
      />
    </template>

    <template #body>
      <div class="space-y-4">
        <UNavigationMenu
          :items="items"
          orientation="vertical"
          class="-mx-2.5"
        />

        <div class="flex flex-col gap-2 border-t border-brand-blue-100 pt-4 dark:border-gray-700">
          <UButton
            to="/postuler"
            variant="soft"
            label="Postuler"
            class="justify-center md:hidden"
            aria-label="Devenir volontaire"
            @click="trackNavigationCta('postuler_mobile')"
          />

          <UButton
            to="/volontaires/connexion"
            target="_blank"
            variant="outline"
            icon="i-heroicons-arrow-right-on-rectangle"
            label="Espace volontaires"
            class="justify-center md:hidden"
            aria-label="Accéder à l'espace volontaires"
            @click="trackNavigationCta('volontaires_connexion_mobile')"
          />
        </div>
      </div>
    </template>
  </UHeader>
</template>
